export const getCountry = (): string =>
    window.dazn.startupData.Region.Country.toLocaleUpperCase();
export const getBootstrapCountry = (): string =>
    window.dazn.startupData.Region.Country;
export const getLanguage = (): string => window.dazn.language;
export const getLocale = (): string => `${getLanguage()}-${getCountry()}`;

export const getSupportedLanguages = (): string[] =>
    window.dazn.startupData.SupportedLanguages;

export const getCurrency = (): string =>
    window.dazn.startupData.Region.Currency;

const minimumFractionDigits = (decimalPlaces: number): number => {
    if (getCountry() === 'JP') {
        return decimalPlaces < 1 ? 0 : 2;
    }
    return decimalPlaces <= 1 ? 2 : 0;
};
const options = (price: any): any => {
    const decimalPlaces = (price.toString().split('.')[1] || '').length;
    return {
        style: 'currency',
        currency: getCurrency(),
        minimumFractionDigits: minimumFractionDigits(decimalPlaces),
        maximumFractionDigits: 4
    };
};
export const formatWithCurrencyV1 = (price: number): string =>
    new Intl.NumberFormat(`${getLocale()}`, options(price)).format(price);
